import Swiper from 'swiper';

const offerSlider = document.querySelector('.js-offers-slider');

if(offerSlider){
    var swiper = new Swiper(offerSlider, {
        loop: true,
        speed: 1000,
        grabCursor: true,
        watchSlidesProgress: true,
        mousewheelControl: true,
        keyboardControl: true,
        //autoHeight: true,
        height: 1600,
        navigation: {
          nextEl: '.js-offer-slider-button-next',
          prevEl: '.js-offer-slider-button-prev',
        },
    });
}
